export function logArray(array: any[]) {
  return { length: array.length, value: array };
}
